<template>
  <div class="scientific-research" :style="{ backgroundImage: `url(${currentAnchor === 0 ? require('@/assets/bg111.png') : require('@/assets/bg222.png')})` }">





    <!-- <div class="navLeftDiv">
         <div class="navbarWrap">
       <div class="navbar">
         <div
           v-for="(item, index) in navList"
           :key="index"
           class="anchor-item"
           :class="{ 'anchor-active': currentAnchor === index, 'anchor-first': index === 0, 'anchor-last': index === navList.length - 1, 'anchor-last2': index === navList.length - 2 }"
           @click="selectTab(index)"
         >
         <div class="anchor-line" v-show="currentAnchor === index"></div>
           <div class="anchor-dot"></div>
           <div class="anchor-content">
           <div class="menuImgDiv">
           <img  :style="{width:item.width,height:item.height}" :src="currentAnchor === index ? item.activeIcon : item.icon" alt="">
           </div>
             <div class="menuTitle"  :class="{ 'menuTitleActive': currentAnchor === index}">
             {{item.name}}
           </div>
           </div>
         </div>

       </div>

     </div>
    </div> -->


    
    <!-- <div class="navLeftDiv">
         <div class="navbarWrap">
       <div class="navbar">
         <div
           v-for="(item, index) in navList"
           :key="index"
           class="anchor-item"
           :class="{ 'anchor-active': currentAnchor === index, 'anchor-first': index === 0, 'anchor-last': index === navList.length - 1, 'anchor-last2': index === navList.length - 2 }"
           @click="selectTab(index)"
         >
         <div class="anchor-line" v-show="currentAnchor === index"></div>
           <div class="anchor-dot"></div>
           <div class="anchor-content">
           <div class="menuImgDiv">
           <img  :style="{width:item.width,height:item.height}" :src="currentAnchor === index ? item.activeIcon : item.icon" alt="">
           </div>
             <div class="menuTitle"  :class="{ 'menuTitleActive': currentAnchor === index}">
             {{item.name}}
           </div>
           </div>
         </div>

       </div>

     </div>
    </div> -->

        <!-- <div class="navLeftDiv">
         <div class="navbarWrap">
       <div class="navbar">
         <div
           v-for="(item, index) in navList"
           :key="index"
           class="anchor-item"
           :class="{ 'anchor-active': currentAnchor === index, 'anchor-first': index === 0, 'anchor-last': index === navList.length - 1, 'anchor-last2': index === navList.length - 2 }"
           @click="selectTab(index)"
         >
         <div class="anchor-line" v-show="currentAnchor === index"></div>
           <div class="anchor-dot"></div>
           <div class="anchor-content">
           <div class="menuImgDiv">
           <img  :style="{width:item.width,height:item.height}" :src="currentAnchor === index ? item.activeIcon : item.icon" alt="">
           </div>
             <div class="menuTitle"  :class="{ 'menuTitleActive': currentAnchor === index}">
             {{item.name}}
           </div>
           </div>
         </div>

       </div>

     </div>
    </div> -->


            <div class="navLeftDiv">
         <div class="navbarWrap">
       <div class="navbar">
         <div
           v-for="(item, index) in navList"
           :key="index"
           class="anchor-item"
           :class="{ 'anchor-active': currentAnchor === index, 'anchor-first': index === 0, 'anchor-last': index === navList.length - 1, 'anchor-last2': index === navList.length - 2 }"
           @click="selectTab(index)"
         >
         <div class="anchor-line" v-show="currentAnchor === index"></div>
           <div class="anchor-dot"></div>
           <div class="anchor-content">
          
             <div class="menuTitle"  :class="{ 'menuTitleActive': currentAnchor === index}">
             {{item.name}}
           </div>
           <div class="menuImgDiv">
            <img  :style="{width:item.width,height:item.height}" :src="currentAnchor === index ? item.activeIcon : item.icon" alt="">
            </div>
           </div>
         </div>

       </div>

     </div>
    </div>

     <div class="navRightDiv">
        <!-- 活动简介 -->
       <ActivityIntro  v-if="currentAnchor === 0" />
       <!-- 发布会展示成果 -->
       <PressResults  v-if="currentAnchor === 1" />
       <!-- 全部入围成果 -->
       <AllResults v-if="currentAnchor === 2"
       />
       <!-- 优质成果落地案例 -->
       <CaseStudies v-if="currentAnchor === 3" />
       <!-- 区域合作推进 -->
       <RegionalCooperation  v-if="currentAnchor === 4" />
     </div>

  </div>
</template>

<script>
import PopupList from './components/PopupList.vue'
import MaskDialog from './components/MaskDialog.vue'
import MaskSeriveDialog from './components/MaskSeriveDialog.vue'
import ActivityIntro from './components/ActivityIntro.vue'
import PressResults from './components/PressResults.vue'
import AllResults from './components/AllResults.vue'
import CaseStudies from './components/CaseStudies.vue'
import RegionalCooperation from './components/RegionalCooperation.vue'
export default {
  name: "ScientificResearch",
  components: {
    PopupList,
    MaskDialog,
    MaskSeriveDialog,
    ActivityIntro,
    PressResults,
    AllResults,
    CaseStudies,
    RegionalCooperation
  },
  data() {
    return {
      // 锚点导航数据
      currentAnchor: 0,
      navList: [
        { name: '活动简介', icon: require('@/assets/cg1.png'), activeIcon: require('@/assets/cg11.png') ,width:'17px',height:'20px'},
        { name: '发布会展示成果', icon: require('@/assets/cg2.png'), activeIcon: require('@/assets/cg22.png') ,width:'22px',height:'21px'},
        { name: '全部入围成果', icon: require('@/assets/cg3.png'), activeIcon: require('@/assets/cg33.png') ,width:'22px',height:'23px'},
        { name: '优质成果落地案例', icon: require('@/assets/cg4.png'), activeIcon: require('@/assets/cg44.png'),width:'18px',height:'20px' },
        { name: '区域合作推进', icon: require('@/assets/cg5.png'), activeIcon: require('@/assets/cg55.png') ,width:'21px',height:'18px'}
      ],
      maskSeriveDialogVisible: false,
      maskSeriveDialogTitle: '',
      projectTotal: 0,
      filter: {
        currPage: 1,
        pageSize: 12,
        game_id:'',
      },
      // 弹框相关数据
      dialogVisible: false,
      dialogTitle: '',
      dialogType: '',
      homeProjectData:[],
      dialogList: [],
      // 遮罩层弹框数据
      maskDialogVisible: false,
      maskDialogTitle: '成果详情',
      currentItem: {},
      // 标记是否正在通过点击滚动（避免滚动监听干扰）
      isScrollingByClick: false,
      scrollTimeout: null,
      gameName:'',
      checkDate:{},
      caseData: [],
      cooperationData: []

    }
  },
  mounted() {
    this.initData()
  },
  watch: {
    $route(to, from) {
      if (to.query.id !== from.query.id) {
        this.initData()
      }
    }
  },
  methods: {
    selectTab(index){
      sessionStorage.removeItem("targetAnchor")
      this.currentAnchor = index
    },
    initData() {
      console.log("sessionStorage.getItem('targetAnchor')",sessionStorage.getItem('targetAnchor'))
      this.currentAnchor = sessionStorage.getItem('targetAnchor')?parseInt(sessionStorage.getItem('targetAnchor')) : 0
      this.filter.game_id = this.$route.query.id
      this.gameName = this.$route.query.name
    //   this.getHomeProjectData()
    //   this.getCheckDate()
    //   this.getCaseData()
    //   this.getCooperationData()
    },
    getCheckDate(){
      this.$API.getCurrGames({id: this.filter.game_id}).then(res => {
        this.checkDate = res.data
      })
    },
    getHomeProjectData(){
      this.$API.getHomeProject(this.filter).then(res => {
        this.homeProjectData = res.data.list;
        this.projectTotal = res.data.pageInfo.allRows;
      })
    },

    // 打开弹框
    handleSeriveClick(type) {
      switch (type) {
        case 1:
          this.maskSeriveDialogTitle = '生态化-落地项目育成工厂';
          break;
        case 2:
          this.maskSeriveDialogTitle = '精准化-供需对接推介活动';
          break;
        case 3:
          this.maskSeriveDialogTitle = '专业化-诊断评价策划业务';
          break;
        case 4:
          this.maskSeriveDialogTitle = '数字化-云网智能服务平台';
          break;
        case 5:
          this.maskSeriveDialogTitle = '常态化-共建科创实体机构';
          break;
        case 6:
          this.maskSeriveDialogTitle = '产业合作';
          break;
        case 7:
          this.maskSeriveDialogTitle = '市场合作';
          break;
        case 8:
          this.maskSeriveDialogTitle = '资本合作';
          break;
        case 9:
          this.maskSeriveDialogTitle = '技术合作';
          break;

      }
      this.maskSeriveDialogVisible = true;
    },
    openDialog(type) {
      this.dialogType = type;
      switch (type) {
        case 'field':
          this.dialogTitle = '成果领域查看';
          break;
        case 'unit':
          this.dialogTitle = '推荐单位查看';
          break;
        case 'person':
          this.dialogTitle = '推荐个人查看';
          break;
        case 'region':
          this.dialogTitle = '成果地区查看';
          break;
      }
      this.dialogVisible = true;
    },
    handleAreaClick(index) {
      const Nominated = window.location.origin + `/#/Nominated?gameId=${this.filter.game_id}&name=${this.gameName}`;
      const Shortlisted = window.location.origin + `/#/Shortlisted?gameId=${this.filter.game_id}&name=${this.gameName}`;
      window.sessionStorage.setItem("topMenuIndex", '');
      window.open(index == 1 ? Nominated : Shortlisted, '_blank');
    },
    // 打开遮罩层弹框
    openMaskDialog(item) {
      this.currentItem = item;
      this.maskDialogTitle = '成果详情 ' + item.name;
      this.maskDialogVisible = true;
    },
    // 点击列表项
    handleItemClick(item) {
      console.log('选中:', item);
      this.dialogVisible = false;
      // 可在此添加筛选逻辑
    },
    sizePagination(e) {
      this.filter.currPage = e
      this.getHomeProjectData()
    },
    currentPagination(e) {
      this.filter.currPage = e
      this.getHomeProjectData()
    },
    handlePageChange(page) {
      this.filter.currPage = page;
      this.getHomeProjectData();
    },
  },

};
</script>

<style scoped>
.navRightDiv{
    margin: 0 auto;
    width: 1200px;
}
.menuTitleActive{
    color: #0366F1 !important;
}
.menuTitle{
font-family: Microsoft YaHei, Microsoft YaHei;
font-weight: bold;
font-size: 18px;
color: #5E6A7A;
line-height: 30px; 
margin-right: 10px;

}
.menuImgDiv{
display: flex;
align-items: center;
}
.navLeftDiv{
    position: absolute;
    left: calc(50% - 810px);
    top: 260px;
}

.navbarWrap{
    z-index: 100;
    font-size: 18px;

}
.navbar{
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: relative;
  padding-left: 0;
  border-right: 1px solid #B1B2B4;
  padding-right: 10px;
}


/* 锚点导航样式（右侧文字左侧线条） */
.anchor-item {
  position: relative;
  cursor: pointer;
  padding: 7px 0;
  width: 100%;
  margin-bottom: 10px;
}

.anchor-first {
  padding-top: 0;
  position: relative;
  top: -10px;
  margin-bottom: 0;
}

.anchor-last {
  padding-bottom: 0;
  margin-bottom: 0;
    position: relative;
  bottom: -10px;
}
.anchor-last2{
    margin-bottom: 0 !important;
}

.anchor-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  line-height: 18px;
  font-size: 14px;
  color: #fff;
  text-align: left;
  cursor: pointer;
  font-weight: 400;
  padding-left: 16px;
}

.anchor-line {
  position: absolute;
  right: -12px;
width: 4px;
height: 26px;
background: linear-gradient( 180deg, #276AF8 0%, #8995EB 100%);
border-radius: 2px 2px 2px 2px;
z-index: 9999;
}

.anchor-text {
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 13px;
  color: red;
}

.anchor-dot {
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: #B1B2B4;
  flex-shrink: 0;
  position: absolute;
  right: -12px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
}

.anchor-first .anchor-dot {
    top: 30%;
}

.anchor-last .anchor-dot {
  top: 70%;
}


.mt50{
  margin-top: 50px !important;
}
.wrap_footer .p-isefc-center {
    margin-top: 150px;
    height: 250px;

}
.wrap_footer .p-isefc-center span {
    display: block;
    height: 80px;
}
.wrap_footer{
  position: relative;
    width: 800px;
    margin: 0 auto;
    font-size: 38px;
    color: #fff; 
    padding-bottom: 300px;
}
.wrap_selection{
  position: relative;
    background-position: 32px;
    width: 1232px;
    padding-left: 32px;
    height: 1416px;
    margin: 0 auto;
    margin-top: 150px;
    margin-bottom: 150px;
}
.wrap_introduce p{
  margin-left: 70px;
    margin-right: 90px;
    padding-top: 60px;
}
.wrap_introduce p span {
    display: block;
    text-indent: 2em;
    margin-top: 20px;
    line-height: 35px;
}
.wrap_introduceDiv{
  padding-left: 32px;
}
.wrap_introduce{
  position: relative;
    background-image: url('../../assets/hdjj.png');
    background-repeat: no-repeat;
    background-color: rgba(0, 0, 0, 0) !important;
    margin-top: 130px;
    height: 770px;
    width: 1232px;
    font-size: 18px;
    color: #fff;
    margin: 0 auto;
    margin-top: 150px;
}
.pcdThree{
  margin-left: 130px !important;
}
.pcdTwo{
  margin-left: 125px !important;
}
.partnerContent{
  display: flex;
}
.partnerContentDiv{
      width: 220px;
    height: 200px;
    padding-top: 105px;
    margin-left: 175px;
    line-height: 2;
    color: #000;
    font-size: 14px;
}
.partnerHeadTitle{
  width: 1000px;
  padding-top: 100px;
    margin-left: 100px;
    font-size: 18px;
    color: #fff;
    line-height: 1.8
}
.partner {
  background-image: url('../../assets/hzhb.png');
  background-repeat: no-repeat;
  background-color: rgba(0, 0, 0, 0) !important;
  margin-top: 200px;
  color: #000;
  height: 750px;
  background-position: 32px;
  width: 1232px;
  margin: 0 auto;
}

.click-area {
  position: absolute;
  cursor: pointer;
}

.area1 {
  top: 167px;
  width: 260px;
  height: 50px;
  left: 240px;
}

.area2 {
  right: 240px;
  top: 167px;
  width: 260px;
  height: 50px;
}

.serive1 {
  top: 117px;
  width: 360px;
  height: 128px;
  left: 422px;
}

.serive2 {
  left: 95px;
  top: 296px;
  width: 360px;
  height: 125px;
}

.serive3 {
  left: 90px;
  top: 477px;
  width: 360px;
  height: 125px;
}

.serive4 {
  right: 102px;
  top: 295px;
  width: 360px;
  height: 128px;
}

.serive5 {
  right: 102px;
  top: 475px;
  width: 360px;
  height: 128px;
}

.hzserive1 {
  top: 138px;
  width: 360px;
  height: 128px;
  left: 98px;
}

.hzserive2 {
  top: 320px;
  width: 360px;
  height: 128px;
  left: 92px;
}

.hzserive3 {
  top: 138px;
  width: 360px;
  height: 128px;
  right: 102px;
}

.hzserive4 {
  top: 320px;
  width: 360px;
  height: 128px;
  right: 102px;
}

.wrap_nav {
  width: 1200px;
  margin: 0 auto;
  margin-top: 150px;
  margin-bottom: 148px;
}

.pageBox {
  width: 100%;
  display: flex;
  justify-content: end;
  cursor: pointer;
}
::v-deep .pageBox .el-input__inner{
  height: 34px;
  font-size: 16px;
}
::v-deep .el-pagination .btn-next .el-icon{
  color: #8C8C8C !important;
}
::v-deep .el-pagination .btn-prev .el-icon {
  color: #8C8C8C !important;
}
::v-deep .el-pagination.is-background .el-pager li {
  color: #8C8C8C !important;
}
::v-deep .el-pagination.is-background .btn-prev {
  background: none;
}

::v-deep .el-pagination .btn-next .el-icon {
  font-size: 18px;
}

::v-deep .el-pagination .btn-prev .el-icon {
  font-size: 18px;
}

::v-deep .btn-next {
  width: 34px;
  height: 34px;
  background-color: #fff !important;
  border-radius: 3px 3px 3px 3px;
  border: 1px solid #D9D9D9;
}

::v-deep .btn-prev {
  width: 34px;
  height: 34px;
  background-color: #fff !important;
  border-radius: 3px 3px 3px 3px;
  border: 1px solid #D9D9D9;
}

::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
  background: #fff;
  border: 1px solid #0366F1;
  border-radius: 3px 3px 3px 3px;
  font-weight: 400;
  font-size: 16px;
  text-align: center;
  font-style: normal;
  text-transform: none;
  color: #0366F1 !important;
}

::v-deep .el-pagination.is-background .el-pager li {
  border-radius: 3px 3px 3px 3px;
  background: #fff;
  width: 34px;
  height: 34px;
  font-weight: 400;
  font-size: 16px;
  text-align: center;
  font-style: normal;
  text-transform: none;
  line-height: 34px;
}

.wrap_content_item_title {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
}

.wrap_content {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  margin: 10px 40px 40px;
  padding: 0 20px;
}

.wrap_content_item {
  border: 0;
  height: 131px;
  width: 225px;
  background-color: rgba(0, 0, 0, 0) !important;
  font-size: 20px;
  background-image: url('../../assets/buttonItem.png');
  background-repeat: no-repeat, repeat-y;
  padding: 20px;
  line-height: 40px;
  overflow: hidden;
  cursor: pointer;
  color: #cdddfc;
  box-sizing: border-box;

}

.wrap_content_item:hover {
  background-image: url('../../assets/buttonItemHover.png');
}

.button_item {
  width: 200px;
  height: 60px;
  margin-left: 50px;
  background: #1890FF;
  text-align: center;
  line-height: 60px;
  font-size: 20px;
  color: #fff;
  border-radius: 4px;
  cursor: pointer;
}

.button_item:hover {
  background: #40A9FF;
}

.wrap_button {
  margin-left: 70px;
  padding-top: 180px;
  display: flex;
  margin-bottom: 40px;
}



.wrap_showPic {
  width: 1200px;
  height: 816px;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
  padding-left: 55px;
  margin-top: 140px;
  position: relative;

 
}

.bigTitle {
  color: #fff;
  font-size: 60px;
  text-align: center;
}

.LmLogoImg {
  margin-top: 80px;
}
.topImg{
  display: flex;
  justify-content: center;
  cursor: pointer;
}
.scientific-research {
  min-height: calc(100vh - 230px);
  
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  position: relative;

}



</style>
